var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentLoader',{attrs:{"loading":_vm.items == null},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('ArtistList',{attrs:{"items":_vm.items}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }